import { render, staticRenderFns } from "./guangdongPrintModel.vue?vue&type=template&id=2d0c6314&scoped=true&"
import script from "./guangdongPrintModel.vue?vue&type=script&lang=js&"
export * from "./guangdongPrintModel.vue?vue&type=script&lang=js&"
import style0 from "./guangdongPrintModel.vue?vue&type=style&index=0&id=2d0c6314&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c6314",
  null
  
)

export default component.exports